import React, { useState } from 'react';

import SubscriptionForm from '@components/SubscriptionForm';
import { OfferOption, SelectedOffer } from '@utils/backend-api/subscribe';

import CorporateInquiry from './CorporateInquiry';
import MultipleOffers from './MultipleOffers';
import SingleOffer from './SingleOffer';

interface SubscribeProps {
  defaultSelectedOffer: SelectedOffer;
  description?: string;
  dob: string;
  isUserCBPT?: boolean;
  offers: OfferOption[];
  stripeCustomerId?: string;
  userEmail?: string;
  userFullName?: string;
  userNextBillingDate?: string;
}

const Subscribe = ({
  defaultSelectedOffer,
  description,
  dob,
  isUserCBPT,
  offers,
  stripeCustomerId,
  userFullName,
  userEmail,
  userNextBillingDate,
}: SubscribeProps) => {
  const [selectedOffer, setSelectedOffer] = useState(defaultSelectedOffer);
  const isSingleOffer = offers.length === 1;

  return (
    <>
      <div className="grid grid-cols-1 gap-16 sm:grid-cols-2 sm:gap-32">
        {isSingleOffer ? (
          <SingleOffer description={description} offer={offers[0]} selectedOffer={selectedOffer} />
        ) : (
          <MultipleOffers
            offers={offers}
            selectedOffer={selectedOffer}
            setSelectedOffer={setSelectedOffer}
          />
        )}
        <SubscriptionForm
          buttonText="Subscribe"
          dob={dob}
          formLocation="subscribe"
          isUserCBPT={isUserCBPT}
          presentedOfferCodes={offers.map((offer) => offer.code)}
          selectedOffer={selectedOffer}
          stripeCustomerId={stripeCustomerId}
          userEmail={userEmail}
          userFullName={userFullName}
          userNextBillingDate={userNextBillingDate}
        />
      </div>
      <CorporateInquiry />
    </>
  );
};

export default Subscribe;
